var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  A opção "),_c('b',[_vm._v("HORÁRIO LIMITE")]),_vm._v(" refere-se as empresas que batem ponto após a meia noite.\n")])
}]

export { render, staticRenderFns }